import React from 'react';
import history from '@/history';
import goto from '@/common/goto';
import { getQuery } from '@/common/utils';
import Container from '@/components/container';
import MaterialSettings from './../../../components/material-settings';

import './index.less';

/*****************
 * 品店策略 - 商品策略 -  触达配置【第一步：素材触达设置】 *
 *****************/
export const StrategySetExtraHeaderProps = {
  backIcon: false,
  background:
    '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
  btns: undefined,
};

const DailyGoodsStrategySet = (props) => {
  const activityId = getQuery('activityId'); //活动ID
  const roomId = getQuery('roomId'); //活动ID
  const jobId = getQuery('jobId'); //策略ID
  const jobName = getQuery('jobName'); //策略ID
  const ruleId = getQuery('ruleId'); //规则ID

  /**
   * 触达成功回调【后续拓展的口子】
   * */
  function onTouchSuccess(data) {
  }

  /**
   * 请选择商品范围
   * data:{ noticeScope: 通知范围	(0-全量触达；1-部分触达)}
   * 决定跳转的地址，全量触达跳列表，部分触达跳商运
   * */
  function onSelectType({ noticeScope }) {
    if (noticeScope) {
      /* 日常活动 - 品店策略 - 商品策略 - 触达配置【第二步：触达商品范围设置】【第二步只要是第一步选了部分触达才进行】*/
      const uniqueId = `TIBAO-DAILY-${activityId}`;
      goto.dailyGoodsStrategyRangeSet(jobName, activityId, roomId, jobId, ruleId, uniqueId, false).push();
    } else {
      history.go(-1);
    }
  }

  return (
    <Container>
      <div className="daily-goods-strategy-set-wrapper">
        <div className="daily-goods-strategy-set-title">素材维护触达设置</div>
        <MaterialSettings onTouchSuccess={onTouchSuccess} onSelectType={onSelectType} />
      </div>
    </Container>
  );
};

export default DailyGoodsStrategySet;
